import { FC, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";


import { Stack } from "capitalrx-components-2.0/lib/layout";
import { Body, Title } from "capitalrx-components-2.0/lib/typography";

import { Auth } from "@/api";
import { AuthenticationContext } from "@/context";
import { getThemeURL } from "@/utils";
import { BackLink } from "@/components";

import styles from "./DocumentsList.module.scss";
import ProviderDocumentsForm from "./ProviderDocumentsForm";


export const ProviderDocumentsList: FC = () => {

  const navigate = useNavigate();

  const { isUserLoggedIn, getUser } = useContext(AuthenticationContext);
  const [user, setUser] = useState<Auth.GetUserResponse>();

  const checkUser = async () =>{
    setUser(await getUser());
  };

  useEffect(() => {
    // Must be logged in to access page
    if (!isUserLoggedIn()) {
      navigate(getThemeURL("LOGIN"));
    }
    checkUser();
  },
  [isUserLoggedIn, getUser, navigate],
  );

  return (
    <Stack spacing="large" className={styles.DocumentsListContainer}>
      <Stack spacing="small">
        <BackLink linkText="Home" />
        <Title>Documents</Title>
        <Body>Download or view documents related to your account</Body>
      </Stack>
      <ProviderDocumentsForm user={user}/>
    </Stack>
  );
};

export default ProviderDocumentsList;
